module.exports = __webpack_public_path__ + "img/member-team1.191704b2.jpg";